// Vendor Components
import React from 'react'

// Components
import Main from '../components/container/main/main'
import Slider from '../components/slider/slider'
import Innovation from '../components/section/innovation/innovation'
import Carousel from '../components/carousel/carousel'
import { parseQueryString } from '../utils/helpers'

function Home(props) {
  const items = props.data.allTemplatesJson.edges
  const { location } = props
  let queryStr
  if (location) {
    queryStr = parseQueryString(location.search.substring(1))
  }
  return (
    <Main
      items={items}
      queryStr={queryStr}
      children={props => {
        return (
          <div className="container-fluid">
            <div className="row">
              <Slider {...props} style={{ height: '100vh' }} />
              <Innovation className="col-12 pepe" id="innovation" />
              <div className="container">
                <Carousel className="col-12 px-0" />
              </div>
            </div>
          </div>
        )
      }}
    />
  )
}

export const query = graphql`
  query ContentQuery {
    allTemplatesJson {
      edges {
        node {
          title
          link
        }
      }
    }
  }
`

export default Home



// WEBPACK FOOTER //
// ./src/pages/index.js